/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Vchip_Type_Ca_FrInputs */

const en_subtitle_export_vchip_type_ca_fr = /** @type {(inputs: Subtitle_Export_Vchip_Type_Ca_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canadian French`)
};

const fr_subtitle_export_vchip_type_ca_fr = /** @type {(inputs: Subtitle_Export_Vchip_Type_Ca_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français canadien`)
};

const de_subtitle_export_vchip_type_ca_fr = /** @type {(inputs: Subtitle_Export_Vchip_Type_Ca_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kanadisches Französisch`)
};

const it_subtitle_export_vchip_type_ca_fr = /** @type {(inputs: Subtitle_Export_Vchip_Type_Ca_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`francese canadese`)
};

const ru_subtitle_export_vchip_type_ca_fr = /** @type {(inputs: Subtitle_Export_Vchip_Type_Ca_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`канадский французский`)
};

const es_subtitle_export_vchip_type_ca_fr = /** @type {(inputs: Subtitle_Export_Vchip_Type_Ca_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`francés canadiense`)
};

const zh_cn2_subtitle_export_vchip_type_ca_fr = /** @type {(inputs: Subtitle_Export_Vchip_Type_Ca_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加拿大法语`)
};

const ja_subtitle_export_vchip_type_ca_fr = /** @type {(inputs: Subtitle_Export_Vchip_Type_Ca_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カナダフランス語`)
};

const hi_subtitle_export_vchip_type_ca_fr = /** @type {(inputs: Subtitle_Export_Vchip_Type_Ca_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कनाडाई फ्रेंच`)
};

const pt_pt2_subtitle_export_vchip_type_ca_fr = /** @type {(inputs: Subtitle_Export_Vchip_Type_Ca_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Francês canadense`)
};

/**
* | output |
* | --- |
* | "Canadian French" |
*
* @param {Subtitle_Export_Vchip_Type_Ca_FrInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_vchip_type_ca_fr = /** @type {((inputs?: Subtitle_Export_Vchip_Type_Ca_FrInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Vchip_Type_Ca_FrInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_vchip_type_ca_fr(inputs)
	if (locale === "de") return de_subtitle_export_vchip_type_ca_fr(inputs)
	if (locale === "it") return it_subtitle_export_vchip_type_ca_fr(inputs)
	if (locale === "ru") return ru_subtitle_export_vchip_type_ca_fr(inputs)
	if (locale === "es") return es_subtitle_export_vchip_type_ca_fr(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_vchip_type_ca_fr(inputs)
	if (locale === "ja") return ja_subtitle_export_vchip_type_ca_fr(inputs)
	if (locale === "hi") return hi_subtitle_export_vchip_type_ca_fr(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_vchip_type_ca_fr(inputs)
	return en_subtitle_export_vchip_type_ca_fr(inputs)
});